export const serializeParams = (params) =>
  Object.entries(params)
    .filter(
      ([, val]) => val != null && !(Array.isArray(val) && val.length === 0)
    )
    .flatMap(([key, val]) =>
      Array.isArray(val)
        ? val.map((v) => `${key}[]=${encodeURIComponent(v)}`)
        : `${key}=${encodeURIComponent(val)}`
    )
    .join('&');
